// extracted by mini-css-extract-plugin
export default {"editable":"InPlaceEditable-module__editable--U3ooU"};